import React from "react";

import AppPage from "components/AppPage";
import AppPageContent from "components/AppPageContent";
import ErrorBoundary from "components/ErrorBoundary";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import { useRacehorse360Api } from "hooks/api";
import DashboardNotifications from "./DashboardNotifications";
import ExamRequirements from "./ExamRequirements";
import Forecast from "./Forecast";
import InfoBlocks from "./InfoBlocks";
import NextDaysActivities from "./NextDaysActivities";
import { getWorkoutRequestsQuery } from "./helper";

import useStyles from "./styles";

const DashboardPage = () => {
  const classes = useStyles();
  const { currentUser } = useLoggedInUser();

  if (!currentUser.isTrainer) {
    return <></>;
  }

  const { useListWorkoutRequests } = useRacehorse360Api();

  const {
    data: dataWorkoutRequestsTotalCount,
    isLoading: isWorkoutRequestsTotalCountLoading,
    refetch: refetchWorkoutRequestsTotalCount
  } = useListWorkoutRequests({
    query: getWorkoutRequestsQuery(currentUser.trainerIds),
    pagingOptions: {
      maxResults: 1,
      includeSummary: true
    }
  });
  const workoutRequestsTotalCount =
    dataWorkoutRequestsTotalCount?.pagingInfo?.totalResults || 0;

  return (
    <AppPage>
      <div className={classes.scrollableContainer}>
        <AppPageContent className={classes.appPageContent}>
          <div className={classes.gridContainer}>
            <ErrorBoundary>
              <InfoBlocks
                className={classes.gridInfo}
                isWorkoutRequestsTotalCountLoading={
                  isWorkoutRequestsTotalCountLoading
                }
                workoutRequestsTotalCount={workoutRequestsTotalCount}
              />
            </ErrorBoundary>

            <ErrorBoundary>
              <DashboardNotifications className={classes.gridNotifications} />
            </ErrorBoundary>

            <ErrorBoundary>
              <ExamRequirements className={classes.gridExamRequirements} />
            </ErrorBoundary>

            <ErrorBoundary>
              <NextDaysActivities
                className={classes.gridNext3Days}
                refetchWorkoutRequestsTotalCount={
                  refetchWorkoutRequestsTotalCount
                }
              />
            </ErrorBoundary>

            <ErrorBoundary>
              <Forecast className={classes.gridForecast} />
            </ErrorBoundary>
          </div>
        </AppPageContent>
      </div>
    </AppPage>
  );
};

export default React.memo(DashboardPage);
